import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash/lang';
import {FormErrors} from '../common';
import UserCreationForm from './UserCreationForm';
import {createUser} from 'api';
import {addFlashMessage} from 'actions/flash-message';
import {formatErrors} from 'actions/errors';
import * as permissions from 'utils/permissions';

class UserCreation extends React.Component {
  static propTypes = {
    onSubmitSuccess: PropTypes.func.isRequired,
    schoolId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(data) {
    const {me, schoolId, formatErrors, addFlashMessage, onSubmitSuccess} = this.props;
    return createUser({
      ...data,
      role: permissions.isTeacher(me.role) ? 'teacher' : data.role.value,
      schoolId: schoolId ? schoolId : !isEmpty(data.school) ? data.school.id : null,
      parentId: !isEmpty(data.parent) ? data.parent.id : null,
    })
      .then(() => {
        addFlashMessage('User has been successfully created!', 'success');
        onSubmitSuccess();
      })
      .catch((err) =>
        formatErrors(err).then((err) => {
          this.setState({
            errors: err,
          });
        }),
      );
  }

  render() {
    const {schoolId} = this.props;
    const {errors} = this.state;
    return (
      <div>
        <h3 className="text-primary-color flex-row-center text-bold">
          <span className="text-red small-margin">Note: </span>
          User will be created directly without receiving an invitation email
        </h3>
        <FormErrors errors={errors} />
        <UserCreationForm schoolId={schoolId} onSubmit={this.handleFormSubmit} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  me: state.account.get('user').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  formatErrors: (...args) => dispatch(formatErrors(...args)),
  addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCreation);
